export default __webpack_public_path__ + "static/14_30-52ff7d16217a7cd7238ef87e6ac39b10.png";